export default {
  hidden: false,
  transfer: {},
  panel: {},
  wallpaper: {},
};
